import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAddPracticePhotosWithoutProviders,
  fetchAddPracticePhotosWithProviders,
  fetchDeletePhotoFromCurrentLocation,
  fetchDeletePhotosFromAllLocation,
  fetchPracticePhotos,
  fetchPracticeProvidersName,
  fetchUpdateImageInformation,
} from "./PracticePhotosActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const practicePhotos = createSlice({
  name: "practicePhotos",
  initialState: {
    isPracticePhotosLoading: false,
    practicePhotosData: [],
    practiceProvidersNameData: [],
    practicePhotosError: null,
    practicePhotosErrorMsg: null,
  },
  reducers: {
    // updatePracticePhotosList:() => {}
    updatePracticePhotosList: (state, action) => {
      console.log(action.payload);
      state.practicePhotosData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPracticePhotos.pending, (state) => {
        state.isPracticePhotosLoading = true;
        state.practicePhotosError = null;
      })
      .addCase(fetchPracticePhotos.fulfilled, (state, action) => {
        state.isPracticePhotosLoading = false;
        // state.practicePhotosData = action.payload;
        state.practicePhotosData =
          action.payload?.data?.data?.mediaItemResponseDTO;
      })
      .addCase(fetchPracticePhotos.rejected, (state, action) => {
        state.isPracticePhotosLoading = false;
        state.practicePhotosError = action.error.message;
      });
    builder
      .addCase(fetchPracticeProvidersName.pending, (state) => {
        // state.isPracticePhotosLoading = true;
        state.practicePhotosError = null;
      })
      .addCase(fetchPracticeProvidersName.fulfilled, (state, action) => {
        // state.isPracticePhotosLoading = false;
        // state.practicePhotosData = action.payload;
        state.practiceProvidersNameData =
          action.payload?.data?.data?.providerNamesResponseDTO;
      })
      .addCase(fetchPracticeProvidersName.rejected, (state, action) => {
        // state.isPracticePhotosLoading = false;
        state.practicePhotosError = action.error.message;
      });
    builder
      .addCase(fetchDeletePhotoFromCurrentLocation.pending, (state) => {
        // state.isPracticePhotosLoading = true;
        state.practicePhotosError = null;
      })
      .addCase(
        fetchDeletePhotoFromCurrentLocation.fulfilled,
        (state, action) => {
          if (!action.payload.success) {
            if (
              action.payload.data?.metadata?.outcome?.additionalDetails[0]
                ?.additionalInfo
            ) {
              state.practicePhotosError = true;
              state.practicePhotosErrorMsg = getApiErrorMessage(
                action.payload.status
              );
            }
          }
        }
      )
      .addCase(
        fetchDeletePhotoFromCurrentLocation.rejected,
        (state, action) => {
          // state.isPracticePhotosLoading = false;
          state.practicePhotosError = action.error.message;
        }
      );
    builder
      .addCase(fetchDeletePhotosFromAllLocation.pending, (state) => {
        // state.isPracticePhotosLoading = true;
        state.practicePhotosError = null;
      })
      .addCase(fetchDeletePhotosFromAllLocation.fulfilled, (state, action) => {
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.practicePhotosError = true;
            state.practicePhotosErrorMsg = getApiErrorMessage(
              action.payload.status
            );
          }
        }
      })
      .addCase(fetchDeletePhotosFromAllLocation.rejected, (state, action) => {
        // state.isPracticePhotosLoading = false;
        state.practicePhotosError = action.error.message;
      });
    builder
      .addCase(fetchAddPracticePhotosWithoutProviders.pending, (state) => {
        // state.isPracticePhotosLoading = true;
        state.practicePhotosError = null;
      })
      .addCase(
        fetchAddPracticePhotosWithoutProviders.fulfilled,
        (state, action) => {
          if (!action.payload.success) {
            if (
              action.payload.data?.metadata?.outcome?.additionalDetails[0]
                ?.additionalInfo
            ) {
              state.practicePhotosError = true;
              state.practicePhotosErrorMsg = getApiErrorMessage(
                action.payload.status
              );
            }
          }
        }
      )
      .addCase(
        fetchAddPracticePhotosWithoutProviders.rejected,
        (state, action) => {
          // state.isPracticePhotosLoading = false;
          state.practicePhotosError = action.error.message;
        }
      );
    builder
      .addCase(fetchAddPracticePhotosWithProviders.pending, (state) => {
        // state.isPracticePhotosLoading = true;
        state.practicePhotosError = null;
      })
      .addCase(
        fetchAddPracticePhotosWithProviders.fulfilled,
        (state, action) => {
          if (!action.payload.success) {
            if (
              action.payload.data?.metadata?.outcome?.additionalDetails[0]
                ?.additionalInfo
            ) {
              state.practicePhotosError = true;
              state.practicePhotosErrorMsg = getApiErrorMessage(
                action.payload.status
              );
            }
          }
        }
      )
      .addCase(
        fetchAddPracticePhotosWithProviders.rejected,
        (state, action) => {
          // state.isPracticePhotosLoading = false;
          state.practicePhotosError = action.error.message;
        }
      );
    builder
      .addCase(fetchUpdateImageInformation.pending, (state) => {
        // state.isPracticePhotosLoading = true;
        state.practicePhotosError = null;
      })
      .addCase(fetchUpdateImageInformation.fulfilled, (state, action) => {
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.practicePhotosError = true;
            state.practicePhotosErrorMsg = getApiErrorMessage(
              action.payload.status
            );
          }
        }
      })
      .addCase(fetchUpdateImageInformation.rejected, (state, action) => {
        // state.isPracticePhotosLoading = false;
        state.practicePhotosError = action.error.message;
      });
  },
});

export const { updatePracticePhotosList } = practicePhotos.actions;
export const practicePhotosReducer = practicePhotos.reducer;
